import type { HtmlAttributes } from '@studio/design-system/props';
import type { ReactElement } from 'react';
import { Preview } from '../preview.jsx';
import { Settings } from './settings.jsx';
import { Content as _Content, Columns } from '#~/common/editor/index.js';

/** Settings `<Content>` component. */
export const Content = (props: HtmlAttributes): ReactElement => (
  <_Content {...props}>
    <Columns>
      <Columns.Column>
        <h3>Source settings</h3>
        <Settings />
      </Columns.Column>

      <div>
        <h3>Preview</h3>
        <Preview />
      </div>
    </Columns>
  </_Content>
);
